// extracted by mini-css-extract-plugin
export default {"counter":"eventMarker_counter__G4E2m","tooltip":"eventMarker_tooltip__XflqA"};